module.exports = __webpack_public_path__ + "media/images/endicott_tree_growth-9a66e332d8c56e27eb312f8cf766826d.jpg";